import { all, call, put, takeLatest } from "redux-saga/effects";
import queryApi from "../../utils/fetchApi";
import Urler from "../../utils/serviceUrl";
import { fetchUserCoinsStart } from "../user/user.actions";
import {
  advanceChallengeRoundFailure,
  advanceChallengeRoundSuccess,
  commenceChallengeFailure,
  commenceChallengeSuccess,
  createChallengeFailure,
  createChallengeSuccess,
  createOneVOneFailure,
  createOneVOneSuccess,
  createTournamentFailure,
  createTournamentSuccess,
  deleteCompetitionFailure,
  deleteCompetitionSuccess,
  editCompetitionFailure,
  editCompetitionSuccess,
  endChallengeFailure,
  endChallengeSuccess,
  fetchCategoriesFailure,
  fetchCategoriesSuccess,
  fetchChallengeLadderFailure,
  fetchChallengeLadderStart,
  fetchChallengeLadderSuccess,
  fetchCompetitionDetailFailure,
  fetchCompetitionDetailStart,
  fetchCompetitionDetailSuccess,
  fetchMyEventsFailure,
  fetchMyEventsSuccess,
  fetchPlatformsFailure,
  fetchPlatformsSuccess,
  fetchPublicEventsFailure,
  fetchPublicEventsSuccess,
  fetchPublicChallengesFailure,
  fetchPublicChallengesSuccess,
  fetchPublicOneVOnesFailure,
  fetchPublicOneVOnesSuccess,
  fetchSupportedGamesFailure,
  fetchSupportedGamesSuccess,
  joinCompetitionFailure,
  joinCompetitionSuccess,
  publishCompetitionFailure,
  publishCompetitionSuccess,
  reportScoreFailure,
  reportScoreSuccess,
  submitChallengeWinnerFailure,
  submitChallengeWinnerSuccess,
  submitDisputeEvidenceFailure,
  submitDisputeEvidenceSuccess,
  unsubscribeCompetitionFailure,
  unsubscribeCompetitionSuccess,
  uploadCompetitionImagesFailure,
  uploadCompetitionImagesSuccess,
  verifyChallengeFailure,
  verifyChallengeSuccess,
  verifyChallengeWinnerFailure,
  verifyChallengeWinnerSuccess,
} from "./competitions.actions";
import competitionActionTypes from "./competitions.types";

export function* createTournament({ payload: { token, tournamentData } }) {
  try {
    let res = yield queryApi({
      method: "POST",
      url: Urler("/tournaments"),
      bearer: token,
      data: tournamentData,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(createTournamentSuccess(res.data?.data || res.data));
    } else {
      yield put(
        createTournamentFailure({
          message: res.message,
          data: res.data || res.body?.data,
        }),
      );
    }
  } catch (e) {
    yield put(createTournamentFailure(e.message));
  }
}

export function* createChallenge({ payload: { token, challengeData } }) {
  try {
    let res = yield queryApi({
      method: "POST",
      url: Urler("/challenges"),
      bearer: token,
      data: challengeData,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(createChallengeSuccess(res.data?.data || res.data));
    } else {
      yield put(
        createChallengeFailure({
          message: res.message,
          data: res.data || res.body?.data,
        }),
      );
    }
  } catch (e) {
    yield put(createChallengeFailure(e.message));
  }
}

export function* createOneVOne({ payload: { token, oneVOneData } }) {
  try {
    let res = yield queryApi({
      method: "POST",
      url: Urler("/1on1"),
      bearer: token,
      data: oneVOneData,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(createOneVOneSuccess(res.data?.data || res.data));
    } else {
      yield put(createOneVOneFailure(res.message));
    }
  } catch (e) {
    yield put(createOneVOneFailure(e.message));
  }
}

export function* fetchCompetitionDetail({ payload: { token, type, id } }) {
  try {
    let endpoint =
      type === "1on1"
        ? `/1on1/${id}`
        : type === "tournament"
          ? `/tournaments/${id}`
          : `/challenges/${id}`;
    console.log("Fetching competition detail:", { endpoint, type, id });
    let res = yield queryApi({
      method: "GET",
      url: Urler(endpoint),
      bearer: token,
    });
    console.log("Competition detail response:", res);
    // Handle both "success" and "Success" status, and different response structures
    if (res.status === "success" || res.status === "Success") {
      // Extract competition data from various response formats
      let competition = null;
      if (res.data?.data) {
        competition = res.data.data;
      } else if (res.data?.tournaments) {
        competition = res.data.tournaments[0];
      } else if (res.data?.challenges) {
        competition = res.data.challenges[0];
      } else if (res.data?.match) {
        competition = res.data.match;
      }
      console.log("Extracted competition:", competition);
      yield put(fetchCompetitionDetailSuccess(competition));
    } else {
      console.log("Competition detail failed:", res.message);
      yield put(fetchCompetitionDetailFailure(res.message));
    }
  } catch (e) {
    console.error("Competition detail error:", e);
    yield put(fetchCompetitionDetailFailure(e.message));
  }
}

export function* joinCompetition({ payload: { token, type, id, userName } }) {
  try {
    let endpoint =
      type === "1on1"
        ? `/1on1/subscribe`
        : type === "tournament"
          ? `/tournaments/subscribe`
          : `/challenges/subscribe`;
    let res = yield queryApi({
      method: "POST",
      url: Urler(endpoint),
      bearer: token,
      data: {
        uniqId: id,
        uname: userName,
      },
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(joinCompetitionSuccess(res.message || "Successfully joined!"));
      yield put(fetchUserCoinsStart(token));
      // Refetch competition detail to update UI
      yield put(fetchCompetitionDetailStart({ token, type, id }));
    } else {
      yield put(
        joinCompetitionFailure(res.message || "Failed to join competition"),
      );
    }
  } catch (e) {
    yield put(joinCompetitionFailure(e.message));
  }
}

export function* fetchMyEvents({ payload: { token, page = 1, limit = 10 } }) {
  try {
    const [tournRes, challRes, oneRes] = yield all([
      queryApi({
        method: "GET",
        url: Urler(`/tournaments/me?page=${page}&limit=${limit}`),
        bearer: token,
      }),
      queryApi({
        method: "GET",
        url: Urler(`/challenges/me?page=${page}&limit=${limit}`),
        bearer: token,
      }),
      queryApi({
        method: "GET",
        url: Urler(`/1on1/me?page=${page}&limit=${limit}`),
        bearer: token,
      }),
    ]);

    const allEvents = {
      tournaments:
        tournRes.status === "Success" ? tournRes.body.tournaments : [],
      challenges: challRes.status === "Success" ? challRes.body.challenges : [],
      oneVOnes: oneRes.status === "Success" ? oneRes.body.matches : [],
      pagination: {
        tournaments: tournRes.pagination || null,
        challenges: challRes.pagination || null,
        oneVOnes: oneRes.pagination || null,
      },
    };
    yield put(fetchMyEventsSuccess(allEvents));
  } catch (e) {
    yield put(fetchMyEventsFailure(e.message));
  }
}

export function* reportScore({
  payload: { token, type, id, winnerId, score, isUpdate },
}) {
  try {
    let endpoint =
      type === "1on1"
        ? (isUpdate ? `/1on1/editAndVerifyWinner/${id}` : `/1on1/addAndVerifyWinner/${id}`)
        : `/${type === "tournament" ? "tournaments" : "challenges"}/${id}/reportScore`;
    let res = yield queryApi({
      method: type === "1on1" ? (isUpdate ? "PATCH" : "PUT") : "PATCH",
      url: Urler(endpoint),
      bearer: token,
      data: type === "1on1" ? { team: winnerId, score } : { winnerId, score },
    });
    if (res.status === "success") {
      yield put(reportScoreSuccess(res.data.data));
      yield put(fetchUserCoinsStart(token));
    } else {
      yield put(reportScoreFailure(res.message));
    }
  } catch (e) {
    yield put(reportScoreFailure(e.message));
  }
}

export function* submitDisputeEvidence({
  payload: { token, type, id, imageUrl, textEvidence },
}) {
  try {
    let res = yield queryApi({
      method: "POST",
      url: Urler(
        type === "1on1"
          ? `/1on1/reportDispute/${id}`
          : `/${type === "tournament" ? "tournaments" : "challenges"}/${id}/reportDispute`
      ),
      bearer: token,
      data: { comment: textEvidence, imageUrl },
    });

    if (res.status === "success") {
      yield put(submitDisputeEvidenceSuccess(res.data.data));
    } else {
      yield put(submitDisputeEvidenceFailure(res.message));
    }
  } catch (e) {
    yield put(submitDisputeEvidenceFailure(e.message));
  }
}

export function* onCreateTournamentStart() {
  yield takeLatest(
    competitionActionTypes.CREATE_TOURNAMENT_START,
    createTournament,
  );
}
export function* onCreateChallengeStart() {
  yield takeLatest(
    competitionActionTypes.CREATE_CHALLENGE_START,
    createChallenge,
  );
}
export function* onCreateOneVOneStart() {
  yield takeLatest(
    competitionActionTypes.CREATE_ONE_V_ONE_START,
    createOneVOne,
  );
}
export function* onFetchCompetitionDetailStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_COMPETITION_DETAIL_START,
    fetchCompetitionDetail,
  );
}
export function* onJoinCompetitionStart() {
  yield takeLatest(
    competitionActionTypes.JOIN_COMPETITION_START,
    joinCompetition,
  );
}
export function* onFetchMyEventsStart() {
  yield takeLatest(competitionActionTypes.FETCH_MY_EVENTS_START, fetchMyEvents);
}
export function* onReportScoreStart() {
  yield takeLatest(competitionActionTypes.REPORT_SCORE_START, reportScore);
}
export function* onSubmitDisputeEvidenceStart() {
  yield takeLatest(
    competitionActionTypes.SUBMIT_DISPUTE_EVIDENCE_START,
    submitDisputeEvidence,
  );
}

export function* fetchPlatforms({ payload: token }) {
  try {
    console.log(
      "Fetching platforms with token:",
      token ? "present" : "missing",
    );
    let res = yield queryApi({
      method: "GET",
      url: Urler("/platforms"),
      bearer: token,
    });
    console.log("Platforms API response:", res);
    if (res.status === "success") {
      yield put(fetchPlatformsSuccess(res.data.data));
    } else {
      yield put(fetchPlatformsFailure(res.message));
    }
  } catch (e) {
    console.error("Platforms fetch error:", e);
    yield put(fetchPlatformsFailure(e.message));
  }
}

export function* onFetchPlatformsStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_PLATFORMS_START,
    fetchPlatforms,
  );
}

export function* fetchCategories() {
  try {
    let res = yield queryApi({
      method: "GET",
      url: Urler("/categories"),
    });
    if (res.status === "success") {
      yield put(fetchCategoriesSuccess(res.data.data));
    } else {
      yield put(fetchCategoriesFailure(res.message));
    }
  } catch (e) {
    yield put(fetchCategoriesFailure(e.message));
  }
}

export function* onFetchCategoriesStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_CATEGORIES_START,
    fetchCategories,
  );
}

export function* fetchSupportedGames() {
  try {
    let res = yield queryApi({
      method: "GET",
      url: Urler("/supportedGames"),
    });
    if (res.status === "success") {
      yield put(fetchSupportedGamesSuccess(res.data.data));
    } else {
      yield put(fetchSupportedGamesFailure(res.message));
    }
  } catch (e) {
    yield put(fetchSupportedGamesFailure(e.message));
  }
}

export function* onFetchSupportedGamesStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_SUPPORTED_GAMES_START,
    fetchSupportedGames,
  );
}

export function* deleteCompetition({ payload: { token, type, id } }) {
  try {
    let endpoint =
      type === "1on1"
        ? `/1on1/${id}`
        : type === "tournament"
          ? `/tournaments/${id}`
          : `/challenges/${id}`;
    let res = yield queryApi({
      method: "DELETE",
      url: Urler(endpoint),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(
        deleteCompetitionSuccess(res.message || "Successfully deleted"),
      );
    } else {
      yield put(deleteCompetitionFailure(res.message));
    }
  } catch (e) {
    yield put(deleteCompetitionFailure(e.message));
  }
}

export function* onDeleteCompetitionStart() {
  yield takeLatest(
    competitionActionTypes.DELETE_COMPETITION_START,
    deleteCompetition,
  );
}

export function* editCompetition({ payload: { token, type, id, updateData } }) {
  try {
    let endpoint =
      type === "1on1"
        ? `/1on1/${id}`
        : type === "tournament"
          ? `/tournaments/${id}`
          : `/challenges/${id}`;
    let res = yield queryApi({
      method: "PATCH",
      url: Urler(endpoint),
      bearer: token,
      data: updateData,
    });
    if (res.status === "success" || res.status === "Success") {
      const competition = res.data?.doc || res.body?.doc || res.data?.data;
      yield put(editCompetitionSuccess(competition));
    } else {
      yield put(
        editCompetitionFailure({
          message: res.message,
          data: res.data || res.body?.data,
        }),
      );
    }
  } catch (e) {
    yield put(editCompetitionFailure(e.message));
  }
}

export function* onEditCompetitionStart() {
  yield takeLatest(
    competitionActionTypes.EDIT_COMPETITION_START,
    editCompetition,
  );
}

export function* publishCompetition({
  payload: { token, type, id, verifiedToStart },
}) {
  try {
    let endpoint =
      type === "1on1"
        ? `/1on1/verify/${id}`
        : type === "tournament"
          ? `/tournaments/verifyTournament/${id}`
          : `/challenges/verifyChallenge/${id}`;
    let res = yield queryApi({
      method: "PATCH",
      url: Urler(endpoint),
      bearer: token,
      data: { verifiedToStart },
    });
    if (res.status === "success" || res.status === "Success") {
      const competition = res.data?.updateTournament || res.data?.data;
      yield put(publishCompetitionSuccess(competition));
      // Refetch to get fresh data
      yield put(fetchCompetitionDetailStart({ token, type, id }));
    } else {
      yield put(publishCompetitionFailure(res.message));
    }
  } catch (e) {
    yield put(publishCompetitionFailure(e.message));
  }
}

export function* onPublishCompetitionStart() {
  yield takeLatest(
    competitionActionTypes.PUBLISH_COMPETITION_START,
    publishCompetition,
  );
}

export function* uploadCompetitionImages({
  payload: { token, type, competitionId, coverImageUrl, additionalImageUrls },
}) {
  try {
    const endpointType = type === "1on1" ? "1on1" : `${type}s`;
    const res = yield queryApi({
      method: "PUT",
      url: Urler(`/${endpointType}/updateImages/${competitionId}`),
      bearer: token,
      data: {
        pictureCover: coverImageUrl,
        pictures: additionalImageUrls,
      },
    });

    if (res.status === "success" || res.status === "Success") {
      yield put(uploadCompetitionImagesSuccess(res.data?.data || res.data));
    } else {
      yield put(
        uploadCompetitionImagesFailure(
          res.message || "Failed to update images",
        ),
      );
    }
  } catch (e) {
    yield put(uploadCompetitionImagesFailure(e.message));
  }
}

export function* onUploadCompetitionImagesStart() {
  yield takeLatest(
    competitionActionTypes.UPLOAD_COMPETITION_IMAGES_START,
    uploadCompetitionImages,
  );
}

export function* fetchPublicEvents({
  payload: { token, eventType, page = 1, limit = 10 },
}) {
  try {
    let endpoint;
    switch (eventType) {
      case "tournaments":
        endpoint = `/tournaments?page=${page}&limit=${limit}`;
        break;
      case "challenges":
        endpoint = `/challenges?page=${page}&limit=${limit}`;
        break;
      case "oneVOnes":
        endpoint = `/1on1?page=${page}&limit=${limit}`;
        break;
      default:
        endpoint = `/tournaments?page=${page}&limit=${limit}`;
    }

    const res = yield queryApi({
      method: "GET",
      url: Urler(endpoint),
      bearer: token,
    });

    if (res.status === "Success" || res.status === "success") {
      const events =
        res.data?.tournaments ||
        res.data?.challenges ||
        res.data?.matches ||
        res.data?.data ||
        [];
      yield put(
        fetchPublicEventsSuccess({
          eventType,
          events,
          pagination: res.pagination || null,
        }),
      );
    } else {
      yield put(fetchPublicEventsFailure(res.message));
    }
  } catch (e) {
    yield put(fetchPublicEventsFailure(e.message));
  }
}

export function* onFetchPublicEventsStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_PUBLIC_EVENTS_START,
    fetchPublicEvents,
  );
}

export function* fetchPublicChallenges({
  payload: { token, page = 1, limit = 10 },
}) {
  try {
    const res = yield queryApi({
      method: "GET",
      url: Urler(`/challenges?page=${page}&limit=${limit}`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      const events = res.data?.challenges || res.data?.data || [];
      yield put(fetchPublicChallengesSuccess({ events, pagination: res.pagination || null }));
    } else {
      yield put(fetchPublicChallengesFailure(res.message));
    }
  } catch (e) {
    yield put(fetchPublicChallengesFailure(e.message));
  }
}

export function* onFetchPublicChallengesStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_PUBLIC_CHALLENGES_START,
    fetchPublicChallenges,
  );
}

export function* fetchPublicOneVOnes({
  payload: { token, page = 1, limit = 10 },
}) {
  try {
    const res = yield queryApi({
      method: "GET",
      url: Urler(`/1on1?page=${page}&limit=${limit}`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      const events = res.data?.matches || res.data?.data || [];
      yield put(fetchPublicOneVOnesSuccess({ events, pagination: res.pagination || null }));
    } else {
      yield put(fetchPublicOneVOnesFailure(res.message));
    }
  } catch (e) {
    yield put(fetchPublicOneVOnesFailure(e.message));
  }
}

export function* onFetchPublicOneVOnesStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_PUBLIC_ONE_V_ONES_START,
    fetchPublicOneVOnes,
  );
}

// Challenge Ladder Sagas
export function* fetchChallengeLadder({ payload: { token, challengeId } }) {
  try {
    let res = yield queryApi({
      method: "GET",
      url: Urler(`/challenges/${challengeId}/pairs`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(fetchChallengeLadderSuccess(res.data?.pairs || res.data));
    } else {
      yield put(fetchChallengeLadderFailure(res.message));
    }
  } catch (e) {
    yield put(fetchChallengeLadderFailure(e.message));
  }
}

export function* onFetchChallengeLadderStart() {
  yield takeLatest(
    competitionActionTypes.FETCH_CHALLENGE_LADDER_START,
    fetchChallengeLadder,
  );
}

// Challenge Winner Management Sagas
export function* submitChallengeWinner({
  payload: { token, pairId, winnerId, winnerName },
}) {
  try {
    let res = yield queryApi({
      method: "POST",
      url: Urler("/winnings/challenge"),
      bearer: token,
      data: { pairId, winnerId, winnerName },
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(submitChallengeWinnerSuccess(res.data));
    } else {
      yield put(submitChallengeWinnerFailure(res.message));
    }
  } catch (e) {
    yield put(submitChallengeWinnerFailure(e.message));
  }
}

export function* onSubmitChallengeWinnerStart() {
  yield takeLatest(
    competitionActionTypes.SUBMIT_CHALLENGE_WINNER_START,
    submitChallengeWinner,
  );
}

export function* verifyChallengeWinner({ payload: { token, pairId } }) {
  try {
    let res = yield queryApi({
      method: "PATCH",
      url: Urler(`/winnings/challenge/verifyWinning/${pairId}`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(verifyChallengeWinnerSuccess(res.data));
    } else {
      yield put(verifyChallengeWinnerFailure(res.message));
    }
  } catch (e) {
    yield put(verifyChallengeWinnerFailure(e.message));
  }
}

export function* onVerifyChallengeWinnerStart() {
  yield takeLatest(
    competitionActionTypes.VERIFY_CHALLENGE_WINNER_START,
    verifyChallengeWinner,
  );
}

export function* advanceChallengeRound({ payload: { token, challengeId } }) {
  try {
    let res = yield queryApi({
      method: "PATCH",
      url: Urler(`/challenges/${challengeId}/moveToNextRound`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(advanceChallengeRoundSuccess(res.data));
      // Refetch ladder to get updated data
      yield put(fetchChallengeLadderStart({ token, challengeId }));
    } else {
      yield put(advanceChallengeRoundFailure(res.message));
    }
  } catch (e) {
    yield put(advanceChallengeRoundFailure(e.message));
  }
}

export function* onAdvanceChallengeRoundStart() {
  yield takeLatest(
    competitionActionTypes.ADVANCE_CHALLENGE_ROUND_START,
    advanceChallengeRound,
  );
}

// Challenge Lifecycle Management Sagas
export function* verifyChallenge({ payload: { token, challengeId } }) {
  try {
    let res = yield queryApi({
      method: "PATCH",
      url: Urler(`/challenges/verifyChallenge/${challengeId}`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(verifyChallengeSuccess(res.data));
    } else {
      yield put(verifyChallengeFailure(res.message));
    }
  } catch (e) {
    yield put(verifyChallengeFailure(e.message));
  }
}

export function* onVerifyChallengeStart() {
  yield takeLatest(
    competitionActionTypes.VERIFY_CHALLENGE_START,
    verifyChallenge,
  );
}

export function* commenceChallenge({ payload: { token, challengeId } }) {
  try {
    let res = yield queryApi({
      method: "PATCH",
      url: Urler(`/challenges/commenceChallenge/${challengeId}`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(commenceChallengeSuccess(res.data));
    } else {
      yield put(commenceChallengeFailure(res.message));
    }
  } catch (e) {
    yield put(commenceChallengeFailure(e.message));
  }
}

export function* onCommenceChallengeStart() {
  yield takeLatest(
    competitionActionTypes.COMMENCE_CHALLENGE_START,
    commenceChallenge,
  );
}

export function* endChallenge({ payload: { token, challengeId } }) {
  try {
    let res = yield queryApi({
      method: "PATCH",
      url: Urler(`/challenges/endChallenge/${challengeId}`),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(endChallengeSuccess(res.data));
    } else {
      yield put(endChallengeFailure(res.message));
    }
  } catch (e) {
    yield put(endChallengeFailure(e.message));
  }
}

export function* onEndChallengeStart() {
  yield takeLatest(competitionActionTypes.END_CHALLENGE_START, endChallenge);
}

// Unsubscribe Saga
export function* unsubscribeCompetition({ payload: { token, type, id } }) {
  try {
    let endpoint =
      type === "1on1"
        ? `/1on1/unsubscribe/${id}`
        : type === "tournament"
          ? `/tournaments/unsubscribe/${id}`
          : `/challenges/unsubscribe/${id}`;
    let res = yield queryApi({
      method: "DELETE",
      url: Urler(endpoint),
      bearer: token,
    });
    if (res.status === "success" || res.status === "Success") {
      yield put(unsubscribeCompetitionSuccess(res.message));
      yield put(fetchUserCoinsStart(token));
    } else {
      yield put(unsubscribeCompetitionFailure(res.message));
    }
  } catch (e) {
    yield put(unsubscribeCompetitionFailure(e.message));
  }
}

export function* onUnsubscribeCompetitionStart() {
  yield takeLatest(
    competitionActionTypes.UNSUBSCRIBE_COMPETITION_START,
    unsubscribeCompetition,
  );
}

export function* competitionsSagas() {
  yield all([
    call(onCreateTournamentStart),
    call(onCreateChallengeStart),
    call(onCreateOneVOneStart),
    call(onFetchCompetitionDetailStart),
    call(onJoinCompetitionStart),
    call(onFetchMyEventsStart),
    call(onReportScoreStart),
    call(onSubmitDisputeEvidenceStart),
    call(onFetchPlatformsStart),
    call(onFetchCategoriesStart),
    call(onFetchSupportedGamesStart),
    call(onDeleteCompetitionStart),
    call(onEditCompetitionStart),
    call(onPublishCompetitionStart),
    call(onUploadCompetitionImagesStart),
    call(onFetchPublicEventsStart),
    call(onFetchPublicChallengesStart),
    call(onFetchPublicOneVOnesStart),
    // Challenge sagas
    call(onFetchChallengeLadderStart),
    call(onSubmitChallengeWinnerStart),
    call(onVerifyChallengeWinnerStart),
    call(onAdvanceChallengeRoundStart),
    call(onVerifyChallengeStart),
    call(onCommenceChallengeStart),
    call(onEndChallengeStart),
    call(onUnsubscribeCompetitionStart),
  ]);
}
